import {gql} from '@apollo/client';

/**
 * 揽收站点（合作仓）下拉：按集散中心查，无 hubId 时应 skip。
 * 服务端取数失败返回空数组而非报错，前端回落显示 ID。
 */
export const GET_POP_PICKUP_SITE_OPTIONS = gql`
    query GetPopPickupSiteOptions($hubId: String!) {
        getPopPickupSiteOptions(hubId: $hubId) {
            id
            name
        }
    }
`;

export interface PickupSiteOption {
    id: string;
    name: string;
}

export interface GetPopPickupSiteOptionsResponse {
    getPopPickupSiteOptions: PickupSiteOption[];
}

/**
 * 揽收司机下拉。
 * 口径为「有揽收任务记录的司机」，下拉可能缺人；
 * 且须与配送司机（getDriverOptions）区分，用错会显示错误姓名。
 */
export const GET_POP_PICKUP_DRIVER_OPTIONS = gql`
    query GetPopPickupDriverOptions {
        getPopPickupDriverOptions {
            driverId
            driverName
        }
    }
`;

export interface PickupDriverOption {
    driverId: string;
    driverName: string;
}

export interface GetPopPickupDriverOptionsResponse {
    getPopPickupDriverOptions: PickupDriverOption[];
}
